export default function CercurileTematicePage() {
  return (
    <div className="bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-start bg-white">
          <div className="sm:w-1/2 md:w-1/3 mb-8 sm:mb-0">
            <img
              src="/proiecte/PNRAS/pnrr.jpg"
              alt="PNRAS Banner"
              className="w-full mx-auto sm:mx-0"
            />
          </div>
          <div className="sm:w-1/2 md:w-2/3 ml-0 sm:ml-8">
            <h1 className="text-3xl font-bold mb-8 text-center sm:text-left">
              LICEUL TEHNOLOGIC ”DR. FLORIAN ULMEANU” ULMENI
            </h1>
            <h2 className="mb-4 text-2xl font-bold">
              Activitatea II-5: Activități extracurriculare desfășurate din
              cadrul proietului ”Calea spre reușită: PNRAS II”
            </h2>
            <p className="text-justify">
              În cadrul acestor activități toti elevii de gimnaziu din perioada
              de implementare, vor fi antrenați în cadrul unor CERCURI DE
              ACTIVITĂȚI EXTRA-CURRICULARE. Aceste cercuri se vor desfășura pe
              centre de interes, lunar, încurajând astfel colaborarea, munca în
              echipă, contribuind atât la eliminarea barierelor de comunicare
              cât și la dezvoltarea personală și dezvoltarea de noi abilități și
              competențe.
            </p>
            <div className="mt-8">
              <h3 className="mb-4 text-xl font-bold">
                Cercul ”Cercetătorii istorici!”
              </h3>
              <p className="mb-4 text-justify">Competențe specifice vizate:</p>
              <ul className="list-disc list-inside space-y-2 mb-4 text-gray-700">
                <li>
                  Identificarea diferențelor temporale dintre evenimenteși
                  procese istorice;
                </li>
                <li>
                  Localizarea în timp și spațiu a faptelor și/sau a proceselor
                  istorice;
                </li>
                <li>
                  Explorarea surselor istorice prin utilizarea instrumentelor
                  specifice gândirii critice;
                </li>
                <li>
                  Stabilirea de asemenări și deosebiri referitoare la
                  evenimente/procese istorice, pe baza unor surse diferite;
                </li>
                <li>Asumarea de roluri în grupuri de lucru;</li>
                <li> Utilizarea dialogului intercultural;</li>
                <li>Utilizarea resurselor multimedia în scopul învățării;</li>
                <li>
                  Asumarea critică a unui set de valori recunoscute social;
                </li>
              </ul>
              <p className="text-justify font-bold">
                <a
                  href="/proiecte/PNRAS/cercurile-tematice/activitati-cerc-istorie"
                  className="text-blue-600 hover:underline"
                >
                  Poze din activități ”Cercetătorii istorici!”
                </a>
              </p>
            </div>
            <div className="mt-8">
              <h3 className="mb-4 text-xl font-bold">
                Cercul ”Cum funcționează lucrurile!”
              </h3>
              <p className="mb-4 text-justify">Competențe specifice vizate:</p>
              <ul className="list-disc list-inside space-y-2 mb-4 text-gray-700">
                <li>
                  Exploatarea proprietăților și fenomenelor fizice în cadrul
                  unor investigații simple;
                </li>
                <li>
                  Formularea unor concluzii simple pe baza datelorexperimentale
                  obținute în cadrul investigațiilor științifice;
                </li>
                <li>
                  Identificarea în natură și în aplicații tehnice uzuale a
                  fenomenelor fizice studiate;
                </li>
                <li>
                  Descrierea calitativă a unor fenomene fizice simple
                  identificate în natură și în aplicații tehnice uzuale;
                </li>
                <li>
                  Respectarea regulilor stabilite pentru protecția propriei
                  persoane, a celorlalți și a mediului în timpul utilizării
                  diferitelor instrumente, aparate, dispozitive;
                </li>
                <li>
                  Extragerea de date și informații științifice relevante din
                  observații proprii;
                </li>
                <li>
                  Organizarea datelor experimentale în diferite forme simple de
                  prezentare;
                </li>
                <li>
                  Formularea unor concluzii simple cu privire la datele obținute
                  și la evoluția propriei experiențe de învățare;
                </li>
                <li>
                  Uilizarea unor mărimi fizice și a unor principii, teoreme,
                  legi, modele fizice pentru a răspunde la întrebări/ probleme
                  care necesită cunoaștere factuală;
                </li>
                <li>
                  Folosirea unor modele simple în rezolvarea de probleme/
                  situații problemă experimentală;
                </li>
              </ul>
              <p className="text-justify font-bold">
                <a
                  href="/proiecte/PNRAS/cercurile-tematice/activitati-cerc-fizica"
                  className="text-blue-600 hover:underline"
                >
                  Poze din activități ”Cum funcționează lucrurile!”
                </a>
              </p>
            </div>
            <div className="mt-8">
              <h3 className="mb-4 text-xl font-bold">
                Cercul ”MIȘCARE, SPORT ȘI SĂNĂTATE!”
              </h3>
              <p className="mb-4 text-justify">Competențe specifice vizate:</p>
              <ul className="list-disc list-inside space-y-2 mb-4 text-gray-700">
                <li>
                  Menținerea stării optime de sănătate a elevilor și creșterea
                  capacității de adaptare a acestora la factori de mediu;
                </li>
                <li>
                  Armonizarea propriei dezvoltări fizice și prevenirea
                  instalării abaterilor posibile de a acesta;
                </li>
                <li>
                  Interes constant pentru participarea independentă a
                  exercițiilor fizice, jocurilor și a diferitelor sporturi;
                </li>
                <li>
                  Manifestarea spiritului de echipă și de intrecere, în funcție
                  de un sistem de reguli acceptate;
                </li>
              </ul>
              <p className="text-justify font-bold">
                <a
                  href="/proiecte/PNRAS/cercurile-tematice/activitati-cerc-sport"
                  className="text-blue-600 hover:underline"
                >
                  Poze din activități ”MIȘCARE, SPORT ȘI SĂNĂTATE!”
                </a>
              </p>
            </div>
            <div className="mt-8">
              <h3 className="mb-4 text-xl font-bold">
                Cercul ”MICII CRTEATIVI!”
              </h3>
              <p className="mb-4 text-justify">Competențe specifice vizate:</p>
              <ul className="list-disc list-inside space-y-2 mb-4 text-gray-700">
                <li>Dezvoltarea atenției la detalii;</li>
                <li>Dezvoltarea abilități practice;</li>
                <li>Promovarea colaborării și a bucuriei festive;</li>
                <li>Promovarea tradițiilor populare românești;</li>
              </ul>
              <p className="text-justify font-bold">
                <a
                  href="/proiecte/PNRAS/cercurile-tematice/activitati-cerc-creativi"
                  className="text-blue-600 hover:underline"
                >
                  Poze din activități ”Micii creativi!”
                </a>
              </p>
            </div>
            <div className="mt-8">
              <h3 className="mb-4 text-xl font-bold">Cercul ”Robotică”</h3>
              <p className="mb-4 text-justify">Competențe specifice vizate:</p>
              <ul className="list-disc list-inside space-y-2 mb-4 text-gray-700">
                <li>Construirea de modele simple de roboți;</li>
                <li>
                  Crearea mediilor simulate de lucru ale modelelor de roboți;
                </li>
                <li>
                  Elaborarea programelor de conducere cu modelele de roboți;
                </li>
                <li>
                  Respectarea regurilor de securitate, ergonomie și etice ăn
                  construirea modelellor de roboți, în conducerea și programarea
                  acestora;
                </li>
              </ul>
              <p className="text-justify font-bold">
                <a
                  href="/proiecte/PNRAS/cercurile-tematice/activitati-cerc-robotica"
                  className="text-blue-600 hover:underline"
                >
                  Poze din activități ”Robotică”
                </a>
              </p>
              <p className="text-justify font-bold">
                <a
                  href="/proiecte/PNRAS/cerc/robotica/robotica.mp4"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:underline"
                >
                  Activități Cercul de Robotică- video
                </a>
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
